
import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import WaterAIAdvisoryTab from '@/components/water/analytics/WaterAIAdvisoryTab';
import WaterConsumptionTab from '@/components/water/analytics/WaterConsumptionTab';
import WaterQualityTab from '@/components/water/analytics/WaterQualityTab';
import WaterAlarmsTab from '@/components/water/analytics/WaterAlarmsTab';
import WaterDeviceDetailsModal from '@/components/water/analytics/WaterDeviceDetailsModal';
import { recentAlarms } from '@/data/water-analytics-data';
import CompactLayout from '@/components/layout/CompactLayout';

const WaterAnalytics = () => {
  const [tab, setTab] = useState("aiAdvisory");
  const [selectedDevice, setSelectedDevice] = useState<null | typeof recentAlarms[0]>(null);
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  const handleDeviceClick = (device: typeof recentAlarms[0]) => {
    setSelectedDevice(device);
    setShowDeviceModal(true);
  };

  const closeDeviceModal = () => {
    setShowDeviceModal(false);
  };

  return (
    <CompactLayout>
      <Tabs defaultValue="aiAdvisory" value={tab} onValueChange={setTab} className="h-full flex flex-col">
        <div className="flex-none overflow-x-auto flex justify-center">
          <TabsList className="bg-white dark:bg-gray-800 p-1 rounded-lg border dark:border-gray-700">
            <TabsTrigger value="aiAdvisory" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">AI Advisory</TabsTrigger>
            <TabsTrigger value="consumption" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Consumption</TabsTrigger>
            <TabsTrigger value="quality" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Water Quality</TabsTrigger>
            <TabsTrigger value="alarms" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Alarms & Alerts</TabsTrigger>
          </TabsList>
        </div>
        
        <div className="flex-1 overflow-hidden mt-2">
          <TabsContent value="aiAdvisory" className="h-full overflow-auto m-0">
            <WaterAIAdvisoryTab />
          </TabsContent>
          
          <TabsContent value="consumption" className="h-full overflow-auto m-0">
            <WaterConsumptionTab />
          </TabsContent>
          
          <TabsContent value="quality" className="h-full overflow-auto m-0">
            <WaterQualityTab />
          </TabsContent>
          
          <TabsContent value="alarms" className="h-full overflow-auto m-0">
            <WaterAlarmsTab onDeviceClick={handleDeviceClick} />
          </TabsContent>
        </div>
      </Tabs>
      
      <WaterDeviceDetailsModal 
        isOpen={showDeviceModal}
        onClose={closeDeviceModal}
        device={selectedDevice}
      />
    </CompactLayout>
  );
};

export default WaterAnalytics;
